import { render, staticRenderFns } from "./UploadDefault.vue?vue&type=template&id=d81ba320&"
import script from "./UploadDefault.vue?vue&type=script&lang=js&"
export * from "./UploadDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports